<template>
  <div class="area-div"
       v-if="isShowArea">
    <div @click="selectLang('zh-tw','香港','HK')">香港</div>
    <div @click="selectLang('zh-tw','台灣','TWN')">台灣</div>
    <div @click="selectLang('zh-tw','澳門','MO')">澳門</div>
    <div @click="selectLang('zh-tw','Singapore','SG')">Singapore</div>
    <div @click="selectLang('zh-tw','Malaysia','MY')">Malaysia</div>
    <div @click="selectLang('ko','한국','KR')">한국</div>
  </div>
</template>
<script>
export default {
  name: 'selectArea_m',
  data() {
    return {

    };
  },
  mounted() {
    if (localStorage.getItem('areaNick')) {
      this.areaNick = localStorage.getItem('areaNick');
    } else {
      if (this.$i18n.locale.indexOf('tw') >= 0) {
        this.lang = '繁體';
        this.language = 'TW';
        this.areaName = 'TWN';
        this.areaNick = '台灣';
      } else if (this.$i18n.locale.indexOf('zh') >= 0) {
        this.lang = '简体';
        this.language = 'CN';
        this.areaName = 'TWN';
        this.areaNick = '台灣';
      } else if (this.$i18n.locale.indexOf('ko') >= 0) {
        this.lang = '한국어';
        this.language = 'KO';
        this.areaName = 'kr';
        this.areaNick = '한국';
      } else {
        this.lang = '한국어';
        this.language = 'KO';
        this.areaName = 'kr';
        this.areaNick = '한국';
      }
      localStorage.setItem('areaName', this.areaName);
      localStorage.setItem('lang', this.$i18n.locale);
      localStorage.setItem('areaNick', this.areaNick);
    };
    this.$emit('getAreaNick', { 'areaNick': this.areaNick });
  },
  methods: {
    selectLang(type, name, region_code) {
      window.gtag('event', 'switch_area');
      this.$i18n.locale = type;
      this.showSwitch = false;
      localStorage.setItem('lang', type);
      localStorage.setItem('areaNick', name);
      localStorage.setItem('areaName', region_code);
      this.areaNick = name;
      this.areaName = region_code;
      if (this.$i18n.locale.indexOf('tw') >= 0) {
        this.lang = '繁體';
        this.language = 'TW';
      } else {
        this.lang = '한국어';
        this.language = 'KO';
      }
      this.$emit('getAreaNick', { 'areaNick': this.areaNick, 'areaName': this.areaName });
    }
  },
  props: ['isShowArea']
};
</script>
<style lang="less">
.area-div {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100vh;
  background: rgba(255, 255, 255, 0.9);
  opacity: 0.9;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  z-index: 9;
  margin-top: 0.98rem;
  div {
    margin-top: 0.7rem;
    font-size: 0.3rem;
    width: 100%;
    text-align: center;
  }
  div:hover {
    color: #fd6b00;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/components/selectArea_m.vue